import { render, staticRenderFns } from "./AddSubjectComponent.vue?vue&type=template&id=56de8326"
import script from "./AddSubjectComponent.vue?vue&type=script&lang=js"
export * from "./AddSubjectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports